import React from "react";
import {injectIntl} from "react-intl";

import CheckBox from "../../PageLayout/CheckBox";
import {markUpDownContextAction, useMarkUpContext} from "./FeaturesSetupMarkUpContext";


const FeaturesSetupMarkPopupHeaderCheckboxes = (props) => {

  const {intl} = props;
  const {markUpDownContextState, markUpDownContextDispatch} = useMarkUpContext();
  const {upDownCheckboxValue, currencyPercentageCheckboxValue, markUpList, activeMarkUpItemIndex} = markUpDownContextState;

  const checkboxClick = (property, value) => {
    markUpDownContextDispatch(markUpDownContextAction({
      [property]: value,
    }))
  }

  return (
    <div className="fs-shipping-setup fs-shipping-setup--small">
      <div className="fs-shipping-setup__cell">
        {["mark_up", "mark_down"].map(checkboxValue => (
          <CheckBox checked={upDownCheckboxValue === checkboxValue}
                    key={checkboxValue}
                    innerStyle="none"
                    type={"tiny"}
                    text={intl.formatMessage({id: "features.setup.markUpDownPopup.checkbox.mark." + checkboxValue})}
                    onChecked={() => checkboxClick("upDownCheckboxValue", checkboxValue)}/>
        ))}
      </div>
      <div className="fs-shipping-setup__cell">
        {["currency", "percentage"].map(checkboxValue => (
          <CheckBox checked={currencyPercentageCheckboxValue === checkboxValue}
                    key={checkboxValue}
                    innerStyle="none"
                    type={"tiny"}
                    text={intl.formatMessage({id: "features.setup.markUpDownPopup.checkbox." + checkboxValue})}
                    onChecked={() => checkboxClick("currencyPercentageCheckboxValue", checkboxValue)}/>
        ))}
      </div>
    </div>
  )
};

export default injectIntl(FeaturesSetupMarkPopupHeaderCheckboxes)
